import infotext from "../content/infotext";
import "./css/Information.css";

function Information() {
    return (
        <section className = "information" >
            {infotext}
        </section>
    );
}

export default Information;